<template>
    <div>
      <!-- NAVIGATION DRAWER -->
      <!-- v-if="isGestor && isMantenimiento" -->
      <v-navigation-drawer
        v-model="drawer"
        app
        :temporary="$vuetify.breakpoint.mobile"
        width="280"
        elevation="0"
        class="grey lighten-5"
        style="border-right: 1px solid #e0e0e0"
        clipped
      >
        <div class="pa-4">
          <div class="d-flex align-center" style="margin-top: 10px;">
            <v-icon color="primary" size="32" class="mr-3">mdi-cog-outline</v-icon>
            <div>
              <div class="subtitle-1 font-weight-bold" style="line-height: 1.2;">Mantenimiento</div>
              <div class="caption grey--text text--darken-1">Panel de Gestión</div>
            </div>
          </div>
        </div>
        
        <v-divider class="mx-4 mb-2"></v-divider>
        
        <v-list nav dense class="px-3">
          <v-list-item 
            v-for="item in sidebarItems" 
            :key="item.value" 
            :to="{ name: item.to }" 
            color="primary"
            class="rounded-lg mb-1"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
    </div>
  </template>
  
  <script>
  import { mapState } from "vuex";
  export default {
    name: 'SidebarMantenimientoGestor',
    data() {
      return {
        drawer: null,
        
      }
    },
    computed: {
      ...mapState(["permisos"]),
      payload() {
        const token = localStorage.getItem('tokenMantenimiento');
        if (!token) return { role: 'operario' };
        try {
          return JSON.parse(atob(token.split('.')[1]));
        } catch (e) {
          return { role: 'operario' };
        }
      },
      sidebarItems() {
        // Definimos si el usuario tiene permisos de administración
        const isAuthorized = this.permisos.includes('administrar-preventivos');

        const items = [
          { 
            title: 'Inicio', 
            icon: 'mdi-home', 
            // Si es admin va a maintenance-admin, si no a maintenance-operario
            to: isAuthorized ? 'mantenimiento-admin' : 'mantenimiento-operario', 
            value: 'inicio',
            adminOnly: false // Visible para todos
          },
          { 
            title: 'Maquinas', 
            icon: 'mdi-robot-industrial', 
            to: 'mantenimiento-maquinas', 
            value: 'maquinas',
            adminOnly: true 
          },
          { 
            title: 'Frecuencias', 
            icon: 'mdi-repeat', 
            to: 'mantenimiento-frecuencias', 
            value: 'frecuencias',
            adminOnly: true 
          },
          { 
            title: 'Plantillas', 
            icon: 'mdi-file-document-multiple-outline', 
            to: 'mantenimiento-plantillas', 
            value: 'plantillas',
            adminOnly: true 
          },
          { 
            title: 'Subcontratas', 
            icon: 'mdi-account-multiple-outline', 
            to: 'mantenimiento-subcontratas', 
            value: 'subcontratas',
            adminOnly: true 
          },
          { 
            title: 'Vacaciones', 
            icon: 'mdi-calendar-clock-outline', 
            to: 'mantenimiento-calendarios', 
            value: 'calendarios',
            adminOnly: true 
          },
          { 
            title: 'Vista global', 
            icon: 'mdi-calendar-check-outline', 
            to: 'mantenimiento-planificacion', 
            value: 'planificacion',
            adminOnly: true 
          },
        ];

        // Filtramos los items: 
        // Si NO es autorizado, solo devolvemos los que NO son adminOnly
        return items.filter(item => {
          if (item.adminOnly) {
            return isAuthorized;
          }
          return true; // El "Inicio" siempre se devuelve
        });
      }
    },
    methods: {
    }
  }
  </script>
  
  <style scoped>
  /* En Vuetify 2, rounded-lg no es una clase estándar de v-list-item, la forzamos */
  .rounded-lg {
    border-radius: 8px !important;
  }
  
  /* Evita que el logo se deforme */
  ::v-deep .v-image__image {
    background-size: contain !important;
  }
  
  /* Ajustes de scroll lateral */
  html, body {
    overflow-x: hidden;
  }
  </style>